import React, { useState, useEffect } from "react";
import ApexCharts from "apexcharts";
import api from "../../../../api";

const months = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i);

// =================== Chart Component ===================
const SpecialtiesChart = ({ month, year }) => {
  const [chartData, setChartData] = useState({ labels: [], data: [] });
  const [noData, setNoData] = useState(false); // just for the message

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get("/avilable-speciality", {
          params: { month, year },
        });

        if (response.data.data && response.data.data.length > 0) {
          setChartData({
            labels: response.data.labels,
            data: response.data.data,
          });
          setNoData(false);
        } else {
          setChartData({ labels: [], data: [] }); // empty chart
          setNoData(true);
        }
      } catch (error) {
        console.error("Error fetching specialties data:", error);
        setChartData({ labels: [], data: [] });
        setNoData(true);
      }
    };

    fetchData();
  }, [month, year]);

  useEffect(() => {
    const chartContainer = document.querySelector("#specialties-bar");

    if (chartContainer) {
      const maxDataValue = Math.max(...chartData.data, 10);
      const maxYAxisValue = Math.ceil(maxDataValue / 20) * 20;

      const options = {
        series: [{ name: "Specialties", data: chartData.data }],
        chart: {
          height: 265,
          type: "bar",
          fontFamily: "Plus Jakarta Sans, sans-serif",
          foreColor: "#adb0bb",
          toolbar: { show: false },
          stacked: true,
        },
        colors: ["#5D87FF"],
        plotOptions: {
          bar: {
            borderRadius: 6,
            columnWidth: "20%",
            borderRadiusApplication: "end",
          },
        },
        stroke: { show: false },
        dataLabels: { enabled: false },
        legend: { show: false },
        grid: { show: false },
        yaxis: {
          tickAmount: 4,
          min: 0,
          max: maxYAxisValue,
          labels: {
            formatter: (val) => val.toFixed(0),
          },
        },
        xaxis: {
          categories: chartData.labels,
          axisTicks: { show: false },
        },
        tooltip: {
          theme: "dark",
          x: { show: false },
        },
      };

      const chart = new ApexCharts(chartContainer, options);
      chart.render();

      return () => chart.destroy();
    }
  }, [chartData]);

  return (
    <>
      <div id="specialties-bar"></div>
      {noData && (
        <div className="text-center mt-3 fw-semibold text-muted">
          Data is Not Available
        </div>
      )}
    </>
  );
};

// =================== Wrapper Card Component ===================
const SpecialtiesCard = () => {
  const [filters, setFilters] = useState({
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear()
  });

  return (
    <div className="card w-100 position-relative overflow-hidden">
      <div className="card-body">
        <div className="d-flex align-items-center justify-content-between mb-4">
          <h5 className="card-title mb-0 fw-semibold">Available Specialties</h5>
          <div className="d-flex gap-2">
            <select
              className="form-select text-dark"
              value={filters.month}
              onChange={(e) =>
                setFilters({ ...filters, month: Number(e.target.value) })
              }
            >
              {months.map((m, i) => (
                <option key={i + 1} value={i + 1}>{m}</option>
              ))}
            </select>
            <select
              className="form-select text-dark"
              value={filters.year}
              onChange={(e) =>
                setFilters({ ...filters, year: Number(e.target.value) })
              }
            >
              {years.map((y) => (
                <option key={y} value={y}>{y}</option>
              ))}
            </select>
          </div>
        </div>

        <SpecialtiesChart 
          month={filters.month} 
          year={filters.year} 
        />

        <div className="d-flex align-items-center justify-content-center">
          <span className="round-8 bg-primary rounded-circle me-2 d-inline-block"></span>
          <span>Present Count</span>
        </div>
      </div>
    </div>
  );
};

export default SpecialtiesCard;
